import React from "react";
import { INPUTS_PAGE_NAV_TITLE } from "pages/InputsPage";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import PageNavigation from "components/common/PageNavigation";
import DocsHelper from "util/DocsHelper";
import { ForwarderInputsOverview } from "./forwarder-inputs-tab";
import ForwarderInputsNotifications from "./states/ForwarderInputsNotifications";
const ForwarderInputsPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Forwarder Inputs" }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: INPUTS_PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(
  PageHeader,
  {
    title: "Forwarder Inputs",
    documentationLink: {
      title: "Inputs documentation",
      path: DocsHelper.PAGES.INPUTS
    }
  },
  /* @__PURE__ */ React.createElement("span", null, "Overview of all inputs configured across forwarder input profiles.")
), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ForwarderInputsNotifications, null), /* @__PURE__ */ React.createElement(ForwarderInputsOverview, null))));
export default ForwarderInputsPage;
